import { createAction, props } from '@ngrx/store';
import { GBMConversationItemModel } from '../../models/GBMessage.model';
import { LeadModel } from '../../models/Lead.model';
import { ReviewModel, ReviewsModel } from '../../models/Review.model';

export enum ReviewsActionTypes {
  getReviewsBegin = '[Messages] Get Reviews begin',
  getReviewsSuccess = '[Messages] Get Reviews success',
  getReviewsFail = '[Messages] Get Reviews failure',

  upsertReviewReplyBegin = '[Messages] Upsert Review Reply begin',
  upsertReviewReplySuccess = '[Messages] Upsert Review Reply success',
  upsertReviewReplyFail = '[Messages] Upsert Review Reply failure',

  deleteReviewReplyBegin = '[Messages] Delete Review Reply begin',
  deleteReviewReplySuccess = '[Messages] Delete Review Reply success',
  deleteReviewReplyFail = '[Messages] Delete Review Reply failure',
}
//GET
export const getReviewsBeginAction = createAction(
  ReviewsActionTypes.getReviewsBegin
);
export const getReviewsSuccessAction = createAction(
  ReviewsActionTypes.getReviewsSuccess,
  props<{ payload: ReviewsModel }>()
);
export const getReviewsFailAction = createAction(
  ReviewsActionTypes.getReviewsFail,
  props<{ errors: any }>()
);

//UPSERT
export const upsertReviewReplyBeginAction = createAction(
  ReviewsActionTypes.upsertReviewReplyBegin,
  props<{
    review: ReviewModel;
    comment: string;
  }>()
);
export const upsertReviewReplySuccessAction = createAction(
  ReviewsActionTypes.upsertReviewReplySuccess,
  props<{ payload: ReviewModel[] }>()
);
export const upsertReviewReplyFaliAction = createAction(
  ReviewsActionTypes.upsertReviewReplyFail,
  props<{ errors: any }>()
);

//DELETE
export const deleteReviewReplyBeginAction = createAction(
  ReviewsActionTypes.deleteReviewReplyBegin,
  props<{ reviewId: string }>()
);
export const deleteReviewReplySuccessAction = createAction(
  ReviewsActionTypes.deleteReviewReplySuccess,
  props<{ payload: ReviewModel[] }>()
);
export const deleteReviewReplyFaliAction = createAction(
  ReviewsActionTypes.deleteReviewReplyFail,
  props<{ errors: any }>()
);
